import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import FlexContainer from 'core-system/FlexContainer'
import FormattingUtils from 'shared/FormattingUtils'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

const ProgressBarContainer = styled.div`
  display: flex;
  height: 0.375rem;
  border-radius: 0.375rem;
  background-color: ${(props) => props.theme.palette.grey.grey200};
  width: 100%;
  overflow: hidden;
`

const ProgressFill = styled.div<{ width: number; color: string }>`
  height: 100%;
  width: ${(props) => Math.min(props.width, 100)}%;
  background-color: ${(props) => props.color};
  border-radius: 0.5rem;
  transition: width 0.3s ease;
`

const ResetText = styled(Text)`
  color: ${(props) => props.theme.palette.text.placeholder};
`

interface BudgetProgressBarProps {
  label: string
  current: number
  total: number
  daysUntilReset?: number
  color: string
}

const BudgetProgressBar: React.FC<BudgetProgressBarProps> = ({
  label,
  current,
  total,
  daysUntilReset,
  color,
}) => {
  const percentage = total > 0 ? (current / total) * 100 : 0

  return (
    <Container>
      <FlexContainer justifyContent='space-between' alignItems='center'>
        <Text variant='body2' textColor='secondary'>
          {label}
        </Text>
        <Text variant='action4'>
          {FormattingUtils.formatDollar(current)} /{' '}
          {FormattingUtils.formatDollar(total)}
        </Text>
      </FlexContainer>
      <ProgressBarContainer>
        <ProgressFill width={percentage} color={color} />
      </ProgressBarContainer>
      {daysUntilReset !== undefined && (
        <ResetText variant='caption'>Resets in {daysUntilReset} days</ResetText>
      )}
    </Container>
  )
}

export default React.memo(BudgetProgressBar)
